import { render, staticRenderFns } from "./DraggableMenuSlot.vue?vue&type=template&id=3a4a448b"
import script from "./DraggableMenuSlot.vue?vue&type=script&lang=js"
export * from "./DraggableMenuSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports